import {useAtomValue} from 'jotai';
import {memo, useEffect, useState} from 'react';
import {KindergartenData, MarkersLayerProps} from '@/map/@types';
import {useNearbyKindergarten} from '@/map/api';
import {nearbyInfoAtom} from '@/map/atom';
import {MARKER_COUNT_LIMIT} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {convertToCoordFromPointCoords} from '@/map/utils';
import {KindergartenMarker} from '../../Markers/NearbyMarker';

const getList = (data?: KindergartenData[]) => {
  const draft: KindergartenData[] = [];

  if (!data) {
    return draft;
  }

  data.forEach((i: KindergartenData) => {
    const index = draft.findIndex(
      (j) => i.name === j.name && i.studentsCount === j.studentsCount
    );

    if (index === -1) {
      const coords = i?.location?.coordinates;
      const point = convertToCoordFromPointCoords(coords);
      const item = {...i};

      if (point) {
        item.position = point;
      }

      draft.push(item);
    }
  });

  return draft;
};

export const KindergartenLayer = memo(({map, bounds}: MarkersLayerProps) => {
  const {selected} = useAtomValue(nearbyInfoAtom);
  const isActive = selected.includes(AreaAnalyticsFilter.KINDERGARTEN);
  const [list, setList] = useState<KindergartenData[]>([]);

  const {data} = useNearbyKindergarten(
    isActive && bounds
      ? {
          limit: MARKER_COUNT_LIMIT,
          ...bounds,
        }
      : undefined
  );

  useEffect(() => {
    if (data?.length) {
      setList((prev) => {
        return getList([
          ...prev.filter(
            (i) => i.position && map.getBounds().hasPoint(i.position)
          ),
          ...data.slice(0, MARKER_COUNT_LIMIT),
        ]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!isActive || !list?.length) {
    return null;
  }

  return (
    <>
      {list.map(
        (i, idx) =>
          !!i.position && (
            <KindergartenMarker
              key={idx + i.name + i.position.toString()}
              map={map}
              position={i.position}
              item={i}
            />
          )
      )}
    </>
  );
});
